import { Record } from 'immutable';

export default class OneflowCollectionRecord extends Record({
  id: undefined,
  name: undefined,
}) {
}
